var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "zx6riyi6xa",
    d: "M3.463 18h9.074C14.453 18 16 16.442 16 14.512v-9.28c0-1.93-1.547-3.488-3.463-3.488h-.37V.698c0-.396-.3-.698-.692-.698-.393 0-.693.302-.693.698v1.046H5.218V.698c0-.396-.3-.698-.693-.698-.392 0-.692.302-.692.698v1.046h-.37C1.547 1.744 0 3.302 0 5.233v9.255C0 16.442 1.57 18 3.463 18zm9.097-1.395H3.463c-1.154 0-2.078-.93-2.078-2.093V8.279h13.23v6.21c.023 1.185-.924 2.116-2.055 2.116zM3.463 3.14h.37V4.65c0 .396.3.698.692.698.393 0 .693-.302.693-.698V3.14h5.587V4.65c0 .396.3.698.693.698.392 0 .692-.302.692-.698V3.14h.37c1.154 0 2.078.93 2.078 2.093v1.65H1.385v-1.65c0-1.14.947-2.093 2.078-2.093z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-520 -218) translate(40 218) translate(484 3)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#18212D",
    fillRule: "nonzero",
    xlinkHref: "#zx6riyi6xa"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/iconCalendar.7104bed6.svg";
export { ForwardRef as ReactComponent };